<template>
  <div class="text-xl font-sans font-medium py-24 relative min-h-screen orange-bkg"> 
    <!--Introduzione-->
    <div v-show="step === 1">
      <p class="px-8">
        {{ $t('The lack of motivation or the temporary lack of stimulus could be traced back to difficulties in the following three areas:') }}
      </p>
      <div class="flex flex-col mt-4 p-8 w-full">
        <button
        @click="step = 2"
        class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow text-sm"
        :class="{ done : active_el == 1 }">{{ $t("You don't believe enough in yourself") }}</button>
        
        
        <button
        v-if="active_el >= 1"
        @click="step = 10"
        class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow text-sm"
        :class="{ done : active_el_two == 2 }">{{ $t("You've lost sight of your goals") }}</button>

        <button
        v-else
        class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow text-sm opacity-40"
        :class="{ done : active_el_two == 2 }">{{ $t("You've lost sight of your goals") }}</button>
        
        
        
        <button
        v-if="active_el_two >= 2"
        @click="step = 17"
        class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow text-sm">{{ $t('Someone constantly belittles you') }}</button>

        <button
        v-else
        class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow text-sm opacity-40">{{ $t('Someone constantly belittles you') }}</button>
      </div>
      <!-- <span>Clicca su uno dei tasti per approfondire.</span> -->
    </div>

    <!--Non credi a sufficienza in te stesso/a-->
      <div v-show="step === 2">
        <p class="px-8">
        {{ $t('The people who get the most results in life are not necessarily the most capable but the ones who believe in themselves the most.') }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>


      <div v-show="step === 3">
        <p class="px-8">
          {{ $t('If we have a relationship with someone who belittles us, or who has belittled us for a long time, after a while we could develop the habit of doing it on our own, thus beginning to doubt ourselves and our abilities.') }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 4">
        <p class="px-8">{{ $t('Do you have someone near you who belittles you?') }}</p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            {{ $t('Yes') }}
          </button>
          <button
            @click="step++"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            No
          </button>
          <button
            @click="step++"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            {{ $t('Some time') }}
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 5">
        <p class="px-8">{{ $t('How do you feel after you deal with this person?') }}</p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            {{ $t('More confident') }}
          </button>
          <button
            @click="step++"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            {{ $t('Less confident') }}
          </button>
           <button
            @click="step++"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            {{ $t('Does not apply to me') }}
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 6">
        <p class="px-8">
          {{ $t('Now, think about two great achievements you have made in your life that you are particularly proud of') }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 7">
        <p class="px-8">
          {{ $t('Write them down below') }}
        </p>
        <div class="mx-8 my-2">
        <input type="text" id="rounded-email" class=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent mb-2" placeholder="Primo risultato"/>
        <input type="text" id="rounded-email" class=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent" placeholder="Secondo risultato"/>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 8">
        <p class="px-8">{{ $t('Here, always remember that you are the person who has achieved those results and not what the environment seems to make you think.') }}</p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 9">
        <p class="px-8">{{ $t('If we do not believe in ourselves, the environment will continue to give us only meagre opportunities.') }}</p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button  @click="step = 1, activate(1)" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

    <!--Hai perso di vista le tue mete-->
      <div v-show="step === 10">
        <p class="px-8">
          {{ $t('All things are created twice: the first time in our mind. It seems that you, busy in a thousand activities, have lost sight of your dreams. To reactivate this process you should write down your goals.') }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 11">
        <p class="px-8">
        
          {{ $t('Imagine three goals you would like to achieve professionally in five years from now') }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 12">
        <p class="px-8">
          {{ $t('Write them down below') }}
        </p>

         <!-- form Goal-->
        <form @submit.prevent="submitGoal">
          <div class="mx-8 my-2">        
            <input type="text" id="goal_one" name="goal_one" v-model="goal_one" class="rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent mb-2" placeholder="Primo obiettivo"/>
            <input type="text" id="goal_two" name="goal_two" v-model="goal_two" class="rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent mb-2" placeholder="Secondo obiettivo"/>
            <input type="text" id="goal_three" name="goal_three" v-model="goal_three" class="rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent" placeholder="Terzo obiettivo"/>
            <!-- <button type="submit"  class="inline-block w-auto bg-pink-600 text-white rounded-full text-xs font-semibold uppercase px-4 py-1 mt-4">ok</button> -->
            <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
            <button type="submit" @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
          </div>
        </form>
      </div>

      <div v-show="step === 13">
        <p class="px-8">
         {{ $t('Now imagine two personal goals you would like to achieve in five years from now') }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div v-show="step === 14">
        <p class="px-8">
          {{ $t('Write them down below') }}
        </p>
        <div class="mx-8 my-2">
        <input type="text" id="rounded-email" class=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent mb-2" placeholder="Primo obiettivo"/>
        <input type="text" id="rounded-email" class=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent" placeholder="Secondo obiettivo"/>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>
      <div v-show="step === 15">
        <p class="px-8">
          {{ $t('Now imagine two goals in the emotional sphere that you would like to achieve in five years from now') }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>
      <div v-show="step === 16">
        <p class="px-8">
        {{ $t('To seal your agreement with the universe, it would be appropriate for you to take a piece of paper and write down your personal and professional goals that you set for yourself in 5 years from now. Click OK when you have done so.') }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step = 1, activatetwo(2)" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

    <!--Qualcuno ti sminuisce su base costante-->

      <div v-show="step === 17"> 
        <p class="px-8">
          {{ $t('Having someone near you who constantly belittles you can bring your self-motivation and self-esteem to zero because after a while you will start to believe them.') }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>

      <div  v-show="step === 18">
        <p class="px-8">{{ $t("After a while, you'll be the one to belittle yourself.") }}</p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div  v-show="step === 19">
        <p class="px-8">
        {{ $t('In case you have a person close to you who belittles you, considering how he/she treats you, is this person really that important to your life?') }}
        </p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            {{ $t('Yes') }}
          </button>
          <button
            @click="step++"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            No
          </button>
          <button
            @click="step++"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            {{ $t("It doesn't apply to me") }}
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 20">
        <p class="px-8">{{ $t('Can you meet her or hang out with her less often?') }}</p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            {{ $t('Yes') }}
          </button>
          <button
            @click="step++"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 21">
        <p class="px-8">
          {{ $t("Are you aware that who is really your friend doesn't just show you what you do wrong but also all the many things you do well?") }}
        </p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++"
            class="font-semibold w-full bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            {{ $t('Yes') }}
          </button>
          <button
            @click="step++"
            class="font-semibold w-full bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 22">
        <p class="px-8">{{ $t('Make a note of how you might manage') }}</p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next(), isComplete = true" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">+</button>
      </div>
 

    <div v-if="isComplete == true && done[5] == 0" class="mx-8">
      <form @submit.prevent="submit">
      <audio autoplay>
        <source src="/sound/money.wav" type="audio/wav" />
      </audio>
      <ul class="flex flex-wrap justify-center">
        <li class="w-1/6">
          <img src="/img/osm-coin.png" alt="gem" />
        </li>
      </ul>
      <p class="p-8 text-center text-2xl text-white font-bold">
        {{ $t('Congratulations!') }}<br /> {{ $t('You have finished this improvement program!!!') }}<br />
        {{ $t("We've awarded you 0.5 OSM Coins!!!") }}
      </p>
      <button
          type="submit"
          class="font-semibold w-full  bg-transparent my-2  py-2 px-4 text-white border border-white rounded-full shadow"
        >
          fine
        </button>
      </form>
    </div>

    <div v-if="isComplete == true && done[5] == 1" class="p-8">
      <h5 class="text-left text-2xl text-white font-bold">
        {{ $t('Congratulations!') }}<br /> {{ $t('You have completed this improvement program again!!!') }}<br />
      </h5>
      <inertia-link :href="route('curricula')" class="inline-block text-white py-2 px-6 border-2 border-white rounded-xl mt-16">
        fine
      </inertia-link>
    </div>

    
  </div>
</template>

<script>
export default {
   props: ['done'],
  data() {
    return {
      step: 1,
      progress: 0,
      isComplete: false,
      active_el: 0,
      active_el_two: 0,
      program_id: 6,
      goal_one: null,
      goal_two: null,
      goal_three: null
    };
  },
  methods: {
    prev() {
      this.step--;
      var stepValue = 10;
      this.progress = this.progress - stepValue;
    },
    next(progress) {
      this.step++;
      var stepValue = 10;
      this.progress = this.progress + stepValue;
    },
    activate:function(el){
        this.active_el = el;
    },
    activatetwo:function(el){
        this.active_el_two = el;
    },
    submitGoal() {
      const data = new FormData()
      data.append('goal_one', this.goal_one);
      data.append('goal_two', this.goal_two);
      data.append('goal_three', this.goal_three);
      this.$inertia.post(this.route('details.store'), data, {
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
      })
    },
    submit() {
      const data = new FormData()
      data.append('program_id', this.program_id)

      this.$inertia.post(this.route('workout.store'), data, {
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
      })
    },
  },
};
</script>

<style>
.done {
  background:#7ED321;
  font-weight:bold;
}

.orange-bkg {
background: #FEB97E;
background: -webkit-linear-gradient(top left, #FEB97E, #FF7170);
background: -moz-linear-gradient(top left, #FEB97E, #FF7170);
background: linear-gradient(to bottom right, #FEB97E, #FF7170);
}
</style>